<template>
  <v-dialog v-model="dialog" persistent width="1200">
    <EditaFechasReprogramacion />
    <VolverEstadoInicialReprogramacion />
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>edit</v-icon> Edición de reprogramación de vacaciones
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text class="py-0 px-3">
          <v-container grid-list-md style="min-width: 100%;" class="p-0">
            <v-layout row wrap>
              <v-flex xs12 md6 class="p-0">
                <span class="texto">
                  <strong class="texto">Fecha desde: </strong
                  >{{ this.form.fecha_desde }}
                </span>
              </v-flex>
              <v-flex xs12 md6 class="p-0">
                <span class="texto">
                  <strong class="texto">Fecha hasta: </strong
                  >{{ this.form.fecha_hasta }}
                </span>
              </v-flex>
              <v-flex xs12 md6 class="p-0">
                <span class="texto">
                  <strong class="texto">Días para reprogramar: </strong
                  >{{ this.form.total_dias }}
                </span>
              </v-flex>
              <v-flex xs12 class="p-0">
                <span class="texto">
                  <strong class="texto"
                    >REPROGRAMACIONES A PONER EN ESTADO INICIAL</strong
                  >
                </span>
              </v-flex>
            </v-layout>

            <v-data-table
              :items="lista_reprogramaciones_sin_edicion"
              class="elevation-1"
              hide-actions
              :headers="headers"
              :loading="loading_tabla2"
              no-data-text="No se tiene registros"
              no-results-text="No se encontraron coincidencias"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">
                  {{ props.item.secuencia }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.fecha_desde }}
                </td>

                <td class="text-xs-center">
                  {{ props.item.fecha_hasta }}
                </td>

                <td class="text-xs-center">
                  {{ props.item.total_dias }}
                </td>
                <td class="text-xs-center">
                  {{ props.item.estado }}
                </td>

                <td class="text-xs-center">
                  <v-btn
                    color="rgb(149,0,255)"
                    icon
                    dark
                    outline
                    title="Volver a estado inicial(Reprogramación aprobada)"
                    @click.prevent="volverEstadoInicial(props.item)"
                  >
                    <v-icon>undo</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
            <v-divider></v-divider>
            <span class="texto">
              <strong class="texto">MODIFICAR REPROGRAMACIONES.</strong>
            </span>
            <v-layout wrap row>
              <v-flex xs12 class="p-0">
                <strong>Ingrese la nueva fecha de su reprogramación: </strong>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field
                  class="text-field-reducido-border"
                  @change="calculaDiasHabiles()"
                  type="date"
                  v-model="form.fecha_desde_rep"
                  label="Fecha inicio"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs 12md4>
                <v-text-field
                  class="text-field-reducido-border"
                  @change="calculaDiasHabiles()"
                  type="date"
                  v-model="form.fecha_hasta_rep"
                  label="Fecha fin"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  class="text-field-reducido-border"
                  v-model="total_dias_solicitados"
                  label="Días"
                  outline
                  clearable
                  disabled
                />
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-btn
                  color="success"
                  block
                  :disabled="!form.fecha_desde_rep || !form.fecha_hasta_rep"
                  @click="agregarReprogramacion()"
                >
                  <v-icon>arrow_downward</v-icon>
                  Registrar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text class="text-md-center">
          <v-progress-circular
            v-if="loading_tabla"
            :size="80"
            :width="7"
            color="purple"
            indeterminate
          ></v-progress-circular>
        </v-card-text>
        <v-card-text v-if="!loading_tabla" class="py-0 px-3">
          <v-container style="min-width: 100%;" class="p-0">
            <v-layout wrap>
              <v-flex>
                <v-data-table
                  :items="lista_reprogramaciones"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                  :loading="loading_tabla"
                  no-data-text="No se tiene registros"
                  no-results-text="No se encontraron coincidencias"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.secuencia }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.fecha_desde }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.fecha_hasta }}
                    </td>

                    <td class="text-xs-center">
                      {{ props.item.total_dias }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.estado }}
                    </td>

                    <td class="text-xs-center">
                      <v-btn
                        color="error"
                        icon
                        title="Eliminar"
                        outline
                        @click.prevent="eliminarReprogramacion(props.item)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                      <v-btn
                        color="#7b68ee"
                        icon
                        title="Editar"
                        outline
                        @click.prevent="editaFechasReprogramacion(props.item)"
                      >
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <span style="font-size:1.2em ;"
                  ><b class="blue--text">TOTAL DÍAS: </b
                  >{{
                    lista_reprogramaciones.reduce(
                      (acumulador, reprogramacion) => {
                        return (
                          acumulador + parseFloat(reprogramacion.total_dias)
                        );
                      },
                      0
                    ) +
                      lista_reprogramaciones_sin_edicion.reduce(
                        (acumulador, reprogramacion) => {
                          return (
                            acumulador + parseFloat(reprogramacion.total_dias)
                          );
                        },
                        0
                      )
                  }}</span
                >
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  class="text-field-reducido-border"
                  type="text"
                  v-model="motivo"
                  label="Motivo"
                  :rules="$validate(['required'])"
                  required
                  outline
                  clearable
                />
              </v-flex>
              <v-flex xs12>
                <v-btn
                  color="blue"
                  block
                  dark
                  @click="save()"
                  :loading="loading"
                >
                  <v-icon>save</v-icon>
                  GUARDAR CAMBIOS
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import EditaFechasReprogramacion from "./EditaFechasReprogramacion.vue";
import VolverEstadoInicialReprogramacion from "./VolverEstadoInicialReprogramacion.vue";
export default {
  // Definición de mixins importados
  mixins: [validate],
  components: {
    EditaFechasReprogramacion,
    VolverEstadoInicialReprogramacion
  },
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      lista_reprogramaciones: [],
      lista_reprogramaciones_sin_edicion: [],
      valid: false,
      loading: false,
      loading_tabla: false,
      loading_tabla2: false,
      total_dias_solicitados: 0,
      vector_fecha_desde: [],
      vector_fecha_hasta: [],
      headers: [
        {
          text: "Nro",
          align: "center",
          sortable: false
        },
        {
          text: "Fecha desde",
          align: "center",
          sortable: false
        },
        {
          text: "Fecha hasta",
          align: "center",
          sortable: false
        },

        {
          text: "Total días",
          align: "center",
          sortable: false
        },
        {
          text: "Estado",
          align: "center",
          sortable: false
        },
        {
          text: "Acción",
          align: "center",
          sortable: false
        }
      ],
      motivos_reprogramacion: [
        { id: 1, valor: "Por motivos laborales" },
        { id: 3, valor: "Baja médica" },
        { id: 4, valor: "Otros" }
      ],
      correlativo_ficticio: -1,
      vector_eliminados: [],
      user: this.$storage.get("user"),
      motivo: null
    };
  },
  async mounted() {
    // await this.verEstadoVacacion();
    this.$bus.$on("openDialogEditarReprogramacionRRHH", async item => {
      this.form = item;
      this.form.motivo_reprogramacion = this.form.motivo_reprogramado;
      this.form.fecha_desde_rep = this.$moment().format("YYYY-MM-DD");
      this.form.fecha_hasta_rep = this.$moment().format("YYYY-MM-DD");
      await this.cargarReprogramaciones();
      await this.calculaDiasHabiles();
      this.dialog = true;
    });
    this.$bus.$on("closeDialogVolverEstadoInicialReprogramacion", async () => {
      await this.cargarReprogramaciones();
    });
  },
  methods: {
    // Metodo para volver a esta inicial
    volverEstadoInicial(item) {
      this.$bus.$emit("openDialogVolverEstadoInicialReprogramacion", item);
    },
    //edita la fecha de reprogramacion
    async editaFechasReprogramacion(item) {
      try {
        let dias_total = this.lista_reprogramaciones.reduce(
          (acumulador, reprogramacion) => {
            return acumulador + parseFloat(reprogramacion.total_dias);
          },
          0
        );
        let dias_total_sin_edicion = this.lista_reprogramaciones_sin_edicion.reduce(
          (acumulador, reprogramacion) => {
            return acumulador + parseFloat(reprogramacion.total_dias);
          },
          0
        );
        item.dias_programados =
          dias_total + dias_total_sin_edicion - parseFloat(item.total_dias);
        item.total_dias_reprogramar = parseFloat(this.form.total_dias);
        item.fecha_desde_padre = this.form.fecha_desde;
        this.$bus.$emit("openDialogEditaFechasReprogramacion", item);
      } catch (error) {
        console.log(error);
      }
    },
    async cargarReprogramaciones() {
      try {
        this.loading_tabla = true;
        this.loading_tabla2 = true;
        //cargamos las vacaciones para volverlas al estado inicial
        let respuesta_ini = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select * from vacaciones.v_vacaciones_reprogramadas vsvp where vsvp.id_padre =${this.form.id_vacacion_programada} and vsvp.id_estado in (55,58,65)"){
                respuesta
              }
            }
          `
        });
        respuesta_ini = respuesta_ini.runQuery.respuesta;
        this.lista_reprogramaciones_sin_edicion = respuesta_ini;
        this.loading_tabla2 = false;
        //cargamos las vacaciones para editarlas
        let respuesta = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta:"select * from vacaciones.v_vacaciones_reprogramadas vsvp where vsvp.id_padre =${this.form.id_vacacion_programada} and vsvp.id_estado in (68,69,70,71)"){
                respuesta
              }
            }
          `
        });
        respuesta = respuesta.runQuery.respuesta;
        this.lista_reprogramaciones = respuesta;
        this.loading_tabla = false;
      } catch (error) {
        console.log(error);
      }
    },
    async agregarReprogramacion() {
      try {
        // Volvemos a calcular el nro de dias entre las 2 fechas
        await this.calculaDiasHabiles();
        if (
          !this.form.fecha_desde_rep ||
          !this.form.fecha_hasta_rep ||
          this.form.total_dias_solicitados <= 0
        ) {
          this.$message.info("Ingrese correctamente las fechas");
          return;
        }
        // Validamos que la reprogramacion este en la misma gestion de al vacacion padre
        let gestion1 = new Date(this.form.fecha_desde_rep).getFullYear();
        let gestion2 = new Date(this.form.fecha_hasta_rep).getFullYear();
        let gestion_original = this.$moment(
          this.form.fecha_desde,
          "DD/MM/YYYY"
        ).year();
        if (gestion1 != gestion_original || gestion2 != gestion_original) {
          this.$message.info(
            `Las reprogramaciones deben estar en la misma gestion de la programacion`
          );
          return;
        }
        // Validamos que no supero las 5 reprogramaciones
        if (this.lista_reprogramaciones.length + 1 > 5) {
          this.$message.info(`Solo puede realizar 5 reprogramaciones`);
          return;
        }
        //Comprobar que los dias de la reprogramacion no exceda a los dias que se tienen en la vacacion programada
        let dias_total_modificacion = this.lista_reprogramaciones.reduce(
          (acumulador, reprogramacion) => {
            return acumulador + parseFloat(reprogramacion.total_dias);
          },
          0
        );
        let dias_total_para_estado_incial = this.lista_reprogramaciones_sin_edicion.reduce(
          (acumulador, reprogramacion) => {
            return acumulador + parseFloat(reprogramacion.total_dias);
          },
          0
        );
        if (
          parseFloat(dias_total_modificacion) +
            parseFloat(dias_total_para_estado_incial) +
            parseFloat(this.total_dias_solicitados) >
          this.form.total_dias
        ) {
          this.$message.info(
            `Excede el total de los días con los que cuenta para reprogramar`
          );
          return;
        }
        //comprobar que no coincida con otros permisos, otra vacaciones, que no sea igual o este dentro de un rango de fechas del vector temporal this.lista_reprogramacines, y que la fecha no sea menor a la fechga a la fecha de la vacacion de la que se quiere hacer reprogramaciones
        let sw_valido = await this.comprobarFechasValidas(
          this.form.fecha_desde_rep,
          this.form.fecha_hasta_rep
        );
        if (!sw_valido) {
          return;
        }
        let nueva_reprogramacion = {
          fecha_desde: this.$moment(this.form.fecha_desde_rep).format(
            "DD/MM/YYYY"
          ),
          fecha_hasta: this.$moment(this.form.fecha_hasta_rep).format(
            "DD/MM/YYYY"
          ),
          total_dias: this.total_dias_solicitados,
          id_vacacion_programada: this.correlativo_ficticio,
          id_persona: this.form.id_persona
        };
        this.lista_reprogramaciones.push(nueva_reprogramacion);
        this.correlativo_ficticio--;
      } catch (error) {
        console.log(error);
      }
    },
    async adicionarElementosAVector(valor) {
      try {
        let v_fecha_desde = [];
        let v_fecha_hasta = [];

        if (this.lista_reprogramaciones.length > 0) {
          this.lista_reprogramaciones.forEach(element => {
            v_fecha_desde.push(element.fecha_desde);
            v_fecha_hasta.push(element.fecha_hasta);
          });
        } else {
          v_fecha_desde = [];
          v_fecha_hasta = [];
        }

        if (valor == 1) {
          return v_fecha_desde;
        }
        if (valor == 2) {
          return v_fecha_hasta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async comprobarFechasValidas(fecha_desde_nueva, fecha_hasta_nueva) {
      try {
        let rpta = true;
        let bandera_vector = 1;
        let p_vector_fecha_desde = [];
        let p_vector_fecha_hasta = [];
        let p_vector_fecha_desde2;
        let p_vector_fecha_hasta2;
        //armando variables para enviar a la funcion
        if (this.lista_reprogramaciones.length == 0) {
          bandera_vector = 0;
        }

        if (this.lista_reprogramaciones.length > 0) {
          p_vector_fecha_desde = await this.adicionarElementosAVector(1);
          p_vector_fecha_hasta = await this.adicionarElementosAVector(2);
          if (p_vector_fecha_desde.length != p_vector_fecha_hasta.length) {
            p_vector_fecha_hasta.pop();
          }

          //convirtiendo en cadena
          p_vector_fecha_desde2 = p_vector_fecha_desde.toString();
          p_vector_fecha_hasta2 = p_vector_fecha_hasta.toString();

          p_vector_fecha_desde2 = "{" + p_vector_fecha_desde2 + "}";
          p_vector_fecha_hasta2 = "{" + p_vector_fecha_hasta2 + "}";
        } else {
          p_vector_fecha_desde2 = null;
          p_vector_fecha_hasta2 = null;
        }
        //${p_vector_fecha_desde},${p_vector_fechas_hasta}
        let respuesta;
        if (this.lista_reprogramaciones.length > 0) {
          respuesta = await this.$service.graphql({
            query: `
          query{
                  runQuery(consulta:"select vacaciones.fn_valida_fechas_reprogramaciones(${parseInt(
                    this.form.id_vacacion_programada
                  )},'${fecha_desde_nueva}','${fecha_hasta_nueva}','${p_vector_fecha_desde2}','${p_vector_fecha_hasta2}',${bandera_vector},${parseInt(
              this.form.rol
            )})"){
                    respuesta
                  }
                }
              `
          });
        } else {
          respuesta = await this.$service.graphql({
            query: `
          query{
                  runQuery(consulta:"select vacaciones.fn_valida_fechas_reprogramaciones(${parseInt(
                    this.form.id_vacacion_programada
                  )},'${fecha_desde_nueva}','${fecha_hasta_nueva}',null,null,${bandera_vector},${parseInt(
              this.form.rol
            )})"){
                    respuesta
                  }
                }
              `
          });
        }
        respuesta = respuesta.runQuery.respuesta[0].fn_valida_fechas_reprogramaciones.split(
          "|"
        );
        if (respuesta[0] == "0") {
          this.$message.warning(respuesta[1]);
          rpta = false;
        }
        return rpta;
      } catch (error) {
        console.log(error);
      }
    },
    eliminarReprogramacion(item) {
      try {
        var lista_tmp = [];
        this.lista_reprogramaciones.forEach(element => {
          if (item.id_vacacion_programada == element.id_vacacion_programada) {
            this.vector_eliminados.push(element);
          } else {
            lista_tmp.push(element);
          }
        });
        this.lista_reprogramaciones = lista_tmp;
      } catch (error) {
        console.log(error);
      }
    },
    async calculaDiasHabiles() {
      let dias = 0;
      let respuesta;
      if (
        this.form.fecha_desde_rep != null &&
        this.form.fecha_hasta_rep != null
      ) {
        try {
          // respuesta = await this.$service.graphql({
          //   query: `
          //     query{
          //       runQuery(consulta:"select control.fn_obtiene_dias_habiles('${this.form.fecha_desde_rep}','${this.form.fecha_hasta_rep}')"){
          //         respuesta
          //       }
          //     }
          //   `
          // });
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select general.fn_cuenta_dias_habiles_por_persona('${
                  this.form.fecha_desde_rep
                }','${this.form.fecha_hasta_rep}',${parseInt(
              this.form.id_persona
            )})"){
                  respuesta
                }
              }
            `
          });
          dias =
            respuesta.runQuery.respuesta[0].fn_cuenta_dias_habiles_por_persona;
        } catch (error) {
          console.log(error);
        }
      }
      this.total_dias_solicitados = dias;
    },
    close() {
      this.form = {};
      this.loading = false;
      this.valid = false;
      this.lista_reprogramaciones = [];
      this.$bus.$emit("closeDialogEditarReprogramacionRRHH");
      this.dialog = false;
    },
    async save() {
      this.loading = true;
      try {
        // Validamos que se ingreso un motivo
        if (!this.motivo) {
          this.$message.info("No ingreso un motivo");
          this.loading = false;
          return;
        }
        // Construimos el JSON para mandar la consulta
        // Agrupamos todas las vacaciones en un solo vector
        var vector_vacaciones = [];
        // Recorremos las las repro sin editar
        // Sumamos papeletas fraccionadas para que sean solo 1
        var l_repro_unicos = [];
        this.lista_reprogramaciones_sin_edicion.forEach(element => {
          // Sumamos papeletas fraccionadas para que sean solo 1
          let vaca_encontrada = l_repro_unicos.find(
            ele => ele.secuencia == element.secuencia &&  ele.fecha_desde == element.fecha_desde  &&  ele.fecha_hasta == element.fecha_hasta 
          );
          let copia = JSON.parse(JSON.stringify(element))
          if (!!vaca_encontrada) {
            // Si cambiamos gestion // F esta solucion fue rapida, mejorar la logica
            copia.fecha_desde =this.$moment(copia.fecha_desde, "DD/MM/YYYY").add(1,'year').format('DD/MM/YYYY'); 
            copia.fecha_hasta =this.$moment(copia.fecha_hasta, "DD/MM/YYYY").add(1,'year').format('DD/MM/YYYY'); 
          } 
          l_repro_unicos.push(copia);
        });
        l_repro_unicos.forEach(element => {
          var data = {
            id: parseInt(element.id_vacacion_programada),
            fecha_inicio: this.$moment(
              element.fecha_desde,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD"),
            fecha_fin: this.$moment(element.fecha_hasta, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            ),
            dias: element.total_dias
          };
          vector_vacaciones.push(data);
        });
        // Recorremos las las repro editadas
        this.lista_reprogramaciones.forEach(element => {
          var data = {
            id: parseInt(element.id_vacacion_programada),
            fecha_inicio: this.$moment(
              element.fecha_desde,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD"),
            fecha_fin: this.$moment(element.fecha_hasta, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            ),
            dias: element.total_dias
          };
          vector_vacaciones.push(data);
        });
        // Construimos el vector de vacaciones borradas
        var vector_borrados = [];
        this.vector_eliminados.forEach(element => {
          var data = {
            id: parseInt(element.id_vacacion_programada),
            fecha_inicio: this.$moment(
              element.fecha_desde,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD"),
            fecha_fin: this.$moment(element.fecha_hasta, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            ),
            dias: element.total_dias
          };
          vector_borrados.push(data);
        });
        // Construimos el objeto a enviar
        const modifica_reprogramacion = {
          id_usuario: this.user.id,
          id_persona: this.form.id_persona,
          motivo: this.motivo,
          id_vacacion_padre: this.form.id_vacacion_programada,
          vacaciones: vector_vacaciones,
          vacaciones_borrar: vector_borrados
        };
        // Ejecutamos la
        let rpta = await this.$service.graphql({
          query: `
            mutation edit( $vacaciones: JSON!){
              modificaReprogramacion(vacaciones: $vacaciones){
                code
                mensaje
              }
            }
          `,
          variables: {
            vacaciones: modifica_reprogramacion
          }
        });
        rpta = rpta.modificaReprogramacion;
        if (rpta.code == 1) {
          this.$message.success(rpta.mensaje);
          this.close();
        } else {
          this.$message.info(rpta.mensaje);
        }
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/EditarReprogramacionRRHH.vue